import { render, staticRenderFns } from "./AffaireBlocInfo.vue?vue&type=template&id=78dea848&scoped=true&"
import script from "./AffaireBlocInfo.vue?vue&type=script&lang=js&"
export * from "./AffaireBlocInfo.vue?vue&type=script&lang=js&"
import style0 from "./AffaireBlocInfo.vue?vue&type=style&index=0&id=78dea848&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78dea848",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/easy_dev/extranet/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('78dea848')) {
      api.createRecord('78dea848', component.options)
    } else {
      api.reload('78dea848', component.options)
    }
    module.hot.accept("./AffaireBlocInfo.vue?vue&type=template&id=78dea848&scoped=true&", function () {
      api.rerender('78dea848', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/AffaireBlocInfo.vue"
export default component.exports